import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  styledGrid: {
    display: "grid",
    gridTemplateRows: "auto",
    alignItems: "center",
  },
}));
export default useStyles;
